import React from "react";
import "./style.css";
import icon from "../assets/Icon.png"
import not from "../assets/not.png";
import add from "../assets/add.png"
import check from "../assets/check.png"
import { LuDownload } from "react-icons/lu";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router";


export default function TeacherProfile() {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;
    return (
        <div className="student_profile">
            <div className="mainAllCoursesHeader">
                <div className="title">
                    <span className="date">{location.state?.courseName}</span>
                    <span className="courseName" style={{fontSize:"24px"}}>Teacher Profile</span>
                </div>
                <div className="profile_icon_2" onClick={()=>{
                    navigate(-1)
                }} >
                   <IoArrowBackOutline/>
                </div>

                <div className="profile_icon">
                    <img src={icon} alt="Profile Icon" />
                </div>
            </div>
            <div className="all_details_report">
            <div className="student_details">
                <h1>{location.state.name}</h1>
                <p className="id" >{location.state.id}</p>
                <div className="downloadReportBtn">
                    <LuDownload/>
                    <p>Download</p>
                </div>
                <div className="student_details_table">
                    {/* <div className="date_day">
                        <p>Id</p>
                        <p>ICDC-QEI00-25-006-015</p>
                    </div> */}
                    <div className="date_day">
                        <p>Month</p>
                        <p>{location.state.month}</p>
                    </div>
                    <div className="cummulations">
                        <div className="cummulations_tab teacher">
                            <div className="label">
                                Total Present
                            </div>
                            <div className="value">
                                {location.state.totalPresent}
                            </div>
                            <img src={add} alt="" />
                        </div>
                        <div className="cummulations_tab teacher">
                        <div className="label">
                                Total Absent
                            </div>
                            <div className="value">
                            {location.state.totalAbsent}
                            </div>
                            <img src={not} alt="" />
                        </div>
                        <div className="cummulations_tab teacher">
                            <div className="label">
                                Paid Hours
                            </div>
                            <div className="value">
                                {location.state.totalPaidHours}
                            </div>
                            <img src={check} alt="" />
                        </div>
                    </div>
                </div>


                <h3>Attendance</h3>

                <div className="student_attendance_table">
                    <div className="student_attendance_table_labels">
                        <div className="day_date teacher">
                            Date
                        </div>
                        <div className="present_absent teacher">
                            Hours
                        </div>
                        <div className="present_absent teacher">
                            Status
                        </div>
                    </div>
                </div>
                {location.state.attendance && location.state.attendance.map((record, index) => (
                <div key={index} className="student_attendance_table_values">
                    <div className="day_date_val teacher">
                        {record.day}
                    </div>
                    <div
                        className={`present_absent_val teacher`}
                    >
                        {record.paidHours}
                    </div>
                    <div
                        className={`present_absent_val teacher ${
                            record.status === "present" ? "present" : "absent"
                        }`}
                    >
                        {record.status.charAt(0).toUpperCase() + record.status.slice(1)}
                    </div>
                </div>
            ))}
            </div>
            </div>
        </div>
    )
}
